import {Check, Color, Size} from '@propellerads/icon';
import {useEffect} from 'react';
import {PasswordIcon, PasswordRule, StyledPasswordValidator} from './style';
import {DefaultRulesParams, PasswordValidatorProps, Rule} from './types';

export const getDefaultRules = ({
  passwordChangeRuleLengthText,
  passwordChangeRuleLatinLowercaseText,
  passwordChangeRuleLatinUppercaseText,
  passwordChangeRuleDigitsText,
  passwordChangeRuleIsEqualText,
}: DefaultRulesParams): Rule[] => [
  {
    test: (value: string) => value.length >= 8,
    label: passwordChangeRuleLengthText,
    key: 'passwordChangeRuleLengthText',
  },
  {
    test: (value: string) => /[a-z]/.test(value),
    label: passwordChangeRuleLatinLowercaseText,
    key: 'passwordChangeRuleLatinLowercaseText',
  },
  {
    test: (value: string) => /[A-Z]/.test(value),
    label: passwordChangeRuleLatinUppercaseText,
    key: 'passwordChangeRuleLatinUppercaseText',
  },
  {
    test: (value: string) => /\d/.test(value),
    label: passwordChangeRuleDigitsText,
    key: 'passwordChangeRuleDigitsText',
  },
  {
    test: (oneValue: string, twoValue: string) => Boolean(oneValue && twoValue && oneValue === twoValue),
    label: passwordChangeRuleIsEqualText,
    key: 'passwordChangeRuleIsEqualText',
  },
];

const PasswordValidator = ({rules, password = '', confirmPassword = '', onTestsPassed}: PasswordValidatorProps) => {
  const testResults = rules.map((rule) => Boolean(rule.test(password, confirmPassword)));

  useEffect(() => {
    if (!onTestsPassed) {
      return;
    }

    onTestsPassed(testResults.every((value) => value));
  }, [password, confirmPassword, rules]);

  return (
    <StyledPasswordValidator>
      {rules.map((rule, index) => (
        <PasswordRule $isPassed={Boolean(testResults[index])} key={rule.key}>
          <PasswordIcon>
            <Check color={rule.test(password, confirmPassword) ? Color.Success : Color.Gray} size={Size.Small} />
          </PasswordIcon>

          {rule.label}
        </PasswordRule>
      ))}
    </StyledPasswordValidator>
  );
};

export default PasswordValidator;

export type {DefaultRulesParams, PasswordValidatorProps, Rule};
